import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const SidechatIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M25 1V19H7L1 25V1H25ZM25 1V10H16L13 13V1H25Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </Svg>
);

SidechatIcon.displayName = 'SidechatIcon';
